import { IconComponent } from './types';

const BuildingIcon: IconComponent = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_615_6243)">
      <path
        d="M4.8 7.1H4.3V7.6V10.7H2.3V6.4V5.9H1.8H1.30298L6 1.67268L10.697 5.9H10.2H9.7V6.4V10.7H7.7V7.6V7.1H7.2H4.8Z"
        stroke="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_615_6243">
        <rect width="12" height="12" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default BuildingIcon;
